module.exports = __webpack_public_path__ + "img/minis-icon.85944404.svg";